import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

const selectProgressStatus = (contentCategory) => {
    try {
        return needAuth.get(`/progressStatus?contentCategory=${contentCategory}`)
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {selectProgressStatus}